/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 11v9m0 0l3.5-3.5M12 20l-3.5-3.5" _stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M4.565 13.951a3.972 3.972 0 01-.993-1.94 3.868 3.868 0 01.194-2.15 4.057 4.057 0 011.328-1.749c.6-.457 1.32-.75 2.08-.847A4.88 4.88 0 019.03 4.9a5.253 5.253 0 012.95-.9c1.057 0 2.088.314 2.949.9a4.88 4.88 0 011.855 2.365c.771.09 1.501.383 2.11.843a4.057 4.057 0 011.343 1.767c.27.695.333 1.447.185 2.175A3.977 3.977 0 0119.395 14" _stroke="#000" stroke-width="1.5" stroke-linecap="round"/>'
  }
})
